const COOKIE_PREFIX = 'eye-able-announcement-dismissed-';

export function announcementDismissalCookieName(id: string): string {
  return `${COOKIE_PREFIX}${encodeURIComponent(id)}`;
}

export function isAnnouncementDismissed(id: string): boolean {
  if (typeof document === 'undefined') return false;

  const cookieName = `${announcementDismissalCookieName(id)}=`;
  return document.cookie
    .split('; ')
    .some((cookie) => cookie.startsWith(cookieName));
}

export function dismissAnnouncement(id: string, expiresAt: string): void {
  if (typeof document === 'undefined') return;

  const expiresAtDate = new Date(expiresAt);
  if (Number.isNaN(expiresAtDate.getTime())) return;

  const secureAttribute =
    typeof window !== 'undefined' && window.location.protocol === 'https:'
      ? '; Secure'
      : '';

  document.cookie = `${announcementDismissalCookieName(id)}=1; Expires=${expiresAtDate.toUTCString()}; Path=/; SameSite=Lax${secureAttribute}`;
}
